(() => {
  const init = (root) => {
    if (!root || root.dataset.sppDealsReady === '1') return;
    root.dataset.sppDealsReady = '1';
    const grid = root.querySelector('[data-spp-grid]');
    if (!grid) return;
    const cards = Array.from(grid.querySelectorAll('[data-spp-product]'));
    const categorySelect = root.querySelector('[data-spp-category-select]');
    const categoryButtons = Array.from(root.querySelectorAll('[data-spp-category]'));
    const brandSelect = root.querySelector('[data-spp-brand]');
    if (brandSelect) {
      const names = new Map();
      cards.forEach((card) => {
        const id = card.dataset.brand || '';
        const label = card.dataset.brandLabel || '';
        if (id && label) names.set(id, label);
      });
      Array.from(names.entries()).sort((a, b) => a[1].localeCompare(b[1])).forEach(([value, label]) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = label;
        brandSelect.appendChild(option);
      });
    }
    const priceSelect = root.querySelector('[data-spp-price]');
    const sortSelect = root.querySelector('[data-spp-sort]');
    const count = root.querySelector('[data-spp-count]');
    const visible = root.querySelector('[data-spp-visible]');
    const empty = root.querySelector('[data-spp-empty]');
    const reset = root.querySelector('[data-spp-reset]');
    const toolbar = root.querySelector('[data-spp-toolbar]');
    const openers = Array.from(root.querySelectorAll('[data-spp-open-filters]'));
    let currentCategory = 'all';
    const apply = () => {
      const brand = brandSelect?.value || 'all';
      const price = priceSelect?.value || 'all';
      const sort = sortSelect?.value || 'featured';
      let shown = 0;
      cards.forEach((card) => {
        const amount = Number(card.dataset.price || 0);
        const categories = card.dataset.categories || '|';
        const passesCategory = currentCategory === 'all' || categories.includes('|' + currentCategory + '|');
        const passesBrand = brand === 'all' || card.dataset.brand === brand;
        const passesPrice = price === 'all' ||
          (price === 'under500' && amount < 50000) ||
          (price === '500-1000' && amount >= 50000 && amount < 100000) ||
          (price === '1000-2000' && amount >= 100000 && amount < 200000) ||
          (price === 'over2000' && amount >= 200000);
        card.hidden = !(passesCategory && passesBrand && passesPrice);
        if (!card.hidden) shown++;
      });
      const compare = (a, b) => {
        if (sort === 'discount') return Number(b.dataset.discount) - Number(a.dataset.discount);
        if (sort === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
        if (sort === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
        if (sort === 'title') return (a.dataset.title || '').localeCompare(b.dataset.title || '');
        return Number(a.dataset.order) - Number(b.dataset.order);
      };
      cards.sort(compare).forEach((card) => grid.appendChild(card));
      if (count) count.textContent = String(shown);
      if (visible) visible.textContent = String(shown);
      if (empty) empty.hidden = shown > 0;
      if (reset) reset.hidden = currentCategory === 'all' && brand === 'all' && price === 'all' && sort === 'featured';
      categoryButtons.forEach((btn) => {
        const active = btn.dataset.sppCategory === currentCategory;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', String(active));
      });
      const countLine = root.querySelector('.spp-deals__count-line');
      if (countLine) countLine.setAttribute('aria-label', shown + (shown === 1 ? ' current offer' : ' current offers'));
    };
    const clear = () => {
      currentCategory = 'all';
      if (categorySelect) categorySelect.value = 'all';
      if (brandSelect) brandSelect.value = 'all';
      if (priceSelect) priceSelect.value = 'all';
      if (sortSelect) sortSelect.value = 'featured';
      apply();
    };
    categoryButtons.forEach((btn) => btn.addEventListener('click', () => {
      currentCategory = btn.dataset.sppCategory || 'all';
      if (categorySelect) categorySelect.value = currentCategory;
      apply();
    }));
    categorySelect?.addEventListener('change', () => { currentCategory = categorySelect.value; apply(); });
    [brandSelect, priceSelect, sortSelect].forEach((sel) => sel?.addEventListener('change', apply));
    reset?.addEventListener('click', clear);
    root.querySelector('[data-spp-reset-all]')?.addEventListener('click', clear);
    openers.forEach((opener) => opener.addEventListener('click', () => {
      const willOpen = !toolbar.classList.contains('is-open') ||
        opener.getAttribute('aria-expanded') !== 'true';
      toolbar.classList.toggle('is-open', willOpen);
      openers.forEach((button) => button.setAttribute('aria-expanded', String(willOpen && button === opener)));
      if (willOpen) {
        const target = opener.dataset.sppOpenFilters === 'sort' ? sortSelect : categorySelect;
        if (target) target.focus({ preventScroll: true });
      }
    }));
    const storageKey = 'spp-deals-favourites-v1';
    let favourites = [];
    try {
      const loaded = JSON.parse(localStorage.getItem(storageKey) || '[]');
      if (Array.isArray(loaded)) favourites = loaded;
    } catch (error) { favourites = []; }
    const hearts = Array.from(root.querySelectorAll('[data-spp-wishlist]'));
    const repaint = () => hearts.forEach((heart) => {
      const saved = favourites.includes(heart.dataset.sppWishlist);
      heart.setAttribute('aria-pressed', String(saved));
      heart.title = saved ? 'Remove from saved favourites' : 'Save to favourites on this device';
    });
    hearts.forEach((heart) => heart.addEventListener('click', () => {
      const handle = heart.dataset.sppWishlist;
      if (!handle) return;
      favourites = favourites.includes(handle) ? favourites.filter((v) => v !== handle) : [...favourites, handle];
      try { localStorage.setItem(storageKey, JSON.stringify(favourites)); } catch (error) { /* Local storage can be unavailable */ }
      repaint();
    }));
    repaint();
    apply();
  };
  const start = (scope = document) => {
    if (scope.matches?.('[data-spp-deals]')) init(scope);
    scope.querySelectorAll?.('[data-spp-deals]').forEach(init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start());
  else start();
  document.addEventListener('shopify:section:load', (event) => start(event.target));
})();